import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { DialogService } from '../../../services/modal-dialogs';
import { AddCreditDialog } from '../../../dialogs/add.credit/add.credit.dialog';
import { CreditItemArray, CreditItem } from '../../../models/domain/credit.item';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { ssApiService } from '../../../services/ss-api.service';
import { AddNotePromptDialog } from '../../../dialogs/add.note.prompt/add.note.prompt.dialog';
import { DeleteCreditRequest } from '../../../models/ss-api/requests/delete.credit.request';
import { UserRolesService } from '../../../services/user.roles.service';
import { EditEventDialog } from '../../../../app/dialogs/edit.event/edit.event.dialog';
import { TrainingEvent } from '../../../models/domain/training.event';
import { SortBot } from '../../../../app/helpers/sort';

@Component({
    selector: 'member-credits',
    templateUrl: './member.credits.component.html',
    styleUrls: ['./member.credits.component.css']
})
export class MemberCreditsComponent implements OnInit {
    CreditSearch: string;
    creditsResultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;

    @Input('Credits') Credits: CreditItemArray;
    @Input('CreditAmount') CreditAmount: number;
    @Input('MemberID') MemberID: number;

    @Input('IsBusy') IsBusy: boolean;

    @Output('onRefresh') onRefresh: EventEmitter<string> = new EventEmitter();

    constructor(private api: ssApiService, private dialogService: DialogService, private sweetAlertService: SweetAlertService, public roles: UserRolesService) { }

    sortByDate() { this.Credits = SortBot.SortAuto<CreditItemArray>(this.Credits, 'Date'); }
    sortByAmount() { this.Credits = SortBot.SortAuto<CreditItemArray>(this.Credits, 'Amount'); }
    sortByDescription() { this.Credits = SortBot.SortAuto<CreditItemArray>(this.Credits, 'Description'); }

    ngOnInit() {

    }

    AddCredit() {
        let disposable = this.dialogService.addDialog(AddCreditDialog, {
            title: 'Add New',
            MemberID: this.MemberID
        }).subscribe(result => {
            disposable.unsubscribe();
            this.refreshCredits();
        });
    }

    DeleteCredit(credit: CreditItem) {
        this.IsBusy = true;

        let disposable = this.dialogService.addDialog(AddNotePromptDialog, {
            title: 'Delete Credit Note',
            message: 'Confirm message',
            MemberID: this.MemberID,
            showCancel: true,
        }, {
            width: 400,
            height: 500,
            IsRequired: true
        }).subscribe(result => {
            disposable.unsubscribe();
            if (result == 'cancel') {
                this.sweetAlertService.swal(
                    {
                        title: 'Canceled!',
                        text: 'Credit not deleted',
                        type: 'warning',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    }).then((response: any) => {
                        this.IsBusy = false;
                    }, (dismiss) => {
                        this.IsBusy = false;
                        return;
                    }); // keep this line to prevent promise error;
                this.IsBusy = false;

            } else {

                let request = new DeleteCreditRequest;
                request.CreditID = credit.ID;
                request.Note = result;

                let subscription = this.api.DeleteCredit(request).subscribe(
                    response => {
                        subscription.unsubscribe();

                        if (response.Result){
                            this.sweetAlertService.swal(
                            {
                                title: 'Success!',
                                text: 'Credit Deleted',
                                type: 'success',
                                showCancelButton: false,
                                showConfirmButton: false,
                                timer: 1500
                            }).then((response: any) => {
                                this.IsBusy = false;
                            }, (dismiss) => {
                                this.IsBusy = false;
                                return;
                            }); // keep this line to prevent promise error;
                        }
                        else{

                            this.sweetAlertService.swal({
                                type: 'error',
                                title: 'Credit Delete Error',
                                text: response.Message
                            }).then(() => { }, () => { });

                        }

                        
                        this.IsBusy = false;
                        this.refreshCredits();
                    }, error => {
                        subscription.unsubscribe();
                        this.IsBusy = false;
                    }
                );

            }
        });
    }

    refreshCredits() {
        this.onRefresh.emit('');
    }

    CalendarTestClick() {
        let disposable = this.dialogService.addDialog(EditEventDialog, {
            title: 'Edit Event',
            event: new TrainingEvent()
        }).subscribe(result => {
            disposable.unsubscribe();
        });
        // this.activeEvent = e.calEvent.event;
    }

    paginateCredits(e) {
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }

    Title() {
        let title = 'Credit Logs';
        let strAmount = "0";
        
        if (this.CreditAmount > 0) 
            strAmount = this.CreditAmount.toFixed(2);

    
        if (this.CreditAmount) {
            title += ' ($' + strAmount + ')';
        }

        return title;
    }

}
